import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { Bot } from 'lucide-react';
import { useUserStore } from '../stores/StoreProvider';
import { UserMessage, AssistantMessage, LoadingMessage, ChatInput } from '../components/chat';

const Chat = observer(() => {
  const userStore = useUserStore();
  const messagesEndRef = useRef(null);

  useEffect(() => {
    console.log('🔍 Chat: User store state:', {
      isAuthenticated: userStore.isAuthenticated,
      accessToken: !!userStore.accessToken,
      profile: userStore.profile,
      hasProfile: userStore.hasProfile
    });
    userStore.fetchMessages();
  }, []);

  // Debug messages changes
  useEffect(() => {
    console.log('🔍 Chat: Messages changed:', userStore.messages);
  }, [userStore.messages]);

  useEffect(() => {
    // Scroll to bottom when messages change
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [userStore.messages]);

  const handleSendMessage = async (message) => {
    console.log('🔍 Chat.handleSendMessage called with:', message);
    await userStore.sendMessage(message);
  };

  const renderMessage = (message) => {
    if (message.role === 'user') {
      return <UserMessage key={message.id} message={message} />;
    } else if (message.role === 'loading') {
      return <LoadingMessage key={message.id} />;
    } else {
      return <AssistantMessage key={message.id} message={message} />;
    }
  };

  return (
    <div className="flex flex-col h-full">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 p-4 flex-shrink-0 w-full">
        <div className="flex items-center">
          <div className="w-10 h-10 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full flex items-center justify-center">
            <Bot className="text-white" size={20} />
          </div>
          <div className="ml-3">
            <h1 className="text-xl font-bold text-gray-900">Coach Biscuit</h1>
            <p className="text-sm text-gray-600">Your AI Hockey Coach</p>
          </div>
        </div>
      </div>

      {/* Messages */}
      <div className="flex-1 overflow-y-auto p-4 space-y-3 bg-gray-50 w-full">
        {userStore.error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
            <div className="flex justify-between items-start">
              <div>
                <strong className="font-bold">Error: </strong>
                <span className="block sm:inline">{userStore.error}</span>
              </div>
              <button
                onClick={() => userStore.setError(null)}
                className="text-red-700 hover:text-red-900"
              >
                ×
              </button>
            </div>
          </div>
        )}
        
        {userStore.loading && userStore.messages.length === 0 ? (
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
          </div>
        ) : (
          <>
            {userStore.messages.slice().reverse().map(renderMessage)}
            <div ref={messagesEndRef} />
          </>
        )}
      </div>

      {/* Input */}
      <div className="flex-shrink-0">
        <ChatInput onSendMessage={handleSendMessage} loading={userStore.loading} />
      </div>
    </div>
  );
});

export default Chat; 